export const ptBR: { [key: string]: any } = {
    'layout.menu.link.report': "Relatórios",

    'report.container.breadcrumb.item.resources':'Signal',
    'report.container.drawer.title': "Relatórios",

    'header.span.welcome':'Bem vindo',
    'profile.button.logout': "Sair",

    'exception.message.404.title':'Página Não Encontrada',
    'exception.message.404.subtitle':'Desculpe, a página que você está procurando não existe neste site',
    'exception.message.400.title':'Pedido ruim',
    'exception.message.400.subtitle':'O navegador enviou uma solicitação que o servidor não entendeu',
    'exception.message.403.title':'Acesso Negado',
    'exception.message.403.subtitle':'Desculpe, você não está autorizado a acessar esta página',
    'exception.message.500.title':'Erro do Servidor Interno.',
    'exception.message.500.subtitle':'Algo aconteceu em nossos sistemas. Por favor, tente novamente e se o problema persistir entre em contato conosco com o seguinte número de bilhete',
    'exception.message.default.thank':'Obrigado',
    
    'share.link.copy.message':'Link copiado para a área de transferência!',

    'empty.description':'Nenhuma informação associada ao usuário foi encontrada.',

    'dataset.container.table.name':'Nome',
    'dataset.container.table.size':'Tamanho',
    'dataset.container.table.createdOn':'Data de criação',
    'dataset.container.table.lastModified':'Data de atualização',

    'dataset.container.input.search':'Escreva aqui',
    'dataset.container.button.loadmore':'Ver mais',
};